import { Helmet } from "react-helmet-async";
import { useSiteSettings } from "../lib/settings";

const DEFAULT = {
  title: "ECO-GEST PATRIMOINE — Économie de la construction, MOEx & OPC",
  description:
    "Bureau d'études basé à Marigny-Saint-Marcel (74). Économie de la construction, maîtrise d'œuvre d'exécution et OPC pour vos projets de logements, tertiaire et équipements publics.",
  image: "https://ecogest-patrimoine.fr/og-image.jpg",
  type: "website",
};

/**
 * SEO meta tags — applied to every page. Falls back to site-wide settings
 * stored in DB (editable via /admin/parametres) then to hard-coded defaults.
 */
export const SEO = ({ title, description, image, path = "", noindex = false }) => {
  const { settings } = useSiteSettings();
  const t = title || settings?.seo_default_title || DEFAULT.title;
  const d = description || settings?.seo_default_description || DEFAULT.description;
  const img = image || settings?.seo_default_image || DEFAULT.image;
  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${baseUrl}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <html lang="fr" />
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="ECO-GEST PATRIMOINE" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default SEO;
